import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";

export function ImageUpload({ value, onChange, label = "Image", testid = "image-upload", aspect = "aspect-video" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const pick = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="field-label">{label}</label>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="preview" className={`${aspect} w-40 rounded-control border border-navy/15 object-cover`} />
          <button type="button" onClick={() => onChange("")} className="absolute -right-2 -top-2 grid h-6 w-6 place-items-center rounded-full bg-brick text-bone" data-testid={`${testid}-remove`}>
            <X size={13} />
          </button>
          <button type="button" onClick={pick} className="mt-2 block font-sans text-[12px] font-bold uppercase tracking-[0.12em] text-teal">
            Replace
          </button>
        </div>
      ) : (
        <button type="button" onClick={pick} disabled={loading} className={`${aspect} flex w-40 flex-col items-center justify-center gap-2 rounded-control border-2 border-dashed border-navy/25 bg-paper text-text-muted transition-colors hover:border-teal`} data-testid={`${testid}-btn`}>
          {loading ? <Loader2 className="animate-spin" size={20} /> : <><Upload size={20} /><span className="font-sans text-[12px] font-bold uppercase tracking-[0.1em]">Upload</span></>}
        </button>
      )}
    </div>
  );
}
